import type { JSX } from 'react';
import { useMemo } from 'react';
import { useClearFocusedAsset } from '@frameio/selection';
import { useManageUploadCaptionsDialog } from '@frameio/shared/hooks/useManageUploadCaptionsDialog';

export type UploadCaptionsReturn = {
  openUploadCaptionsDialog: (assetId: string | undefined | null) => void;
  uploadCaptionsDialog: JSX.Element;
};

export const useUploadCaptions = (): UploadCaptionsReturn => {
  const clearFocusedAssetId = useClearFocusedAsset();

  const { createUploadCaptionsDialog, openUploadCaptionsDialog } =
    useManageUploadCaptionsDialog();

  const captionsDialog = useMemo(
    () =>
      createUploadCaptionsDialog({
        onClose: clearFocusedAssetId,
      }),
    [clearFocusedAssetId, createUploadCaptionsDialog]
  );

  return {
    openUploadCaptionsDialog,
    uploadCaptionsDialog: captionsDialog,
  };
};
